import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'forgot.password.page.title': {
    id: 'forgot.password.page.title',
    defaultMessage: 'Forgot Password | {siteName}',
    description: 'forgot password page title',
  },
  'forgot.password.page.heading': {
    id: 'forgot.password.page.heading',
    defaultMessage: 'Reset password',
    description: 'The page heading for the forgot password page.',
  },
  'forgot.password.page.instructions': {
    id: 'forgot.password.page.instructions',
    defaultMessage: 'Please enter your username or email address below and we will send you an email with instructions on how to reset your password.',
    description: 'Instructions message for forgot password page.',
  },
  'forgot.password.username.page.instructions': {
    id: 'forgot.password.username.page.instructions',
    defaultMessage: 'Please enter your username below and we will send you an email with instructions on how to reset your password.',
    description: 'Instructions message for forgot password page using username.',
  },
  'forgot.password.email.page.instructions': {
    id: 'forgot.password.email.page.instructions',
    defaultMessage: 'Please enter your email below and we will send you an email with instructions on how to reset your password.',
    description: 'Instructions message for forgot password page using email.',
  },
  'forgot.password.page.invalid.email.message': {
    id: 'forgot.password.page.invalid.email.message',
    defaultMessage: 'Enter a valid email address',
    description: 'Invalid email address message for input field.',
  },
  'forgot.password.page.email.field.label': {
    id: 'forgot.password.page.email.field.label',
    defaultMessage: 'Email',
    description: 'Email field label for the forgot password page.',
  },
  'forgot.password.page.username.field.label': {
    id: 'forgot.password.page.username.field.label',
    defaultMessage: 'Username',
    description: 'Username field label for the forgot password page.',
  },
  'forgot.password.page.emailorUsername.field.label': {
    id: 'forgot.password.page.emailorUsername.field.label',
    defaultMessage: 'Username or email',
    description: 'Validation message that appears when email is empty',
  },
  'forgot.password.page.submit.button': {
    id: 'forgot.password.page.submit.button',
    defaultMessage: '{label}',
    description: 'Submit button text for the forgot password page.',
  },
  'forgot.password.error.alert.title': {
    id: 'forgot.password.error.alert.title.',
    defaultMessage: 'We were unable to contact you.',
    description: 'Failed to send password recovery email.',
  },
  'forgot.password.error.message.title': {
    id: 'forgot.password.error.message.title',
    defaultMessage: 'An error occurred.',
    description: 'Title for message that appears when error occurs for password assistance page',
  },
  'forgot.password.request.in.progress.message': {
    id: 'forgot.password.request.in.progress.message',
    defaultMessage: 'Your previous request is in progress, please try again in a few moments.',
    description: 'Message displayed when previous password reset request is still in progress.',
  },
  'forgot.password.empty.email.field.error': {
    id: 'forgot.password.empty.email.field.error',
    defaultMessage: 'Enter your email',
    description: 'Error message that appears when user tries to submit empty email field',
  },
  'forgot.password.empty.username.field.error': {
    id: 'forgot.password.empty.username.field.error',
    defaultMessage: 'Enter your username',
    description: 'Error message that appears when user tries to submit empty username field',
  },
  'forgot.password.empty.emailorUsername.field.error': {
    id: 'forgot.password.empty.emailorUsername.field.error',
    defaultMessage: 'Enter your email or username',
    description: 'Error message that appears when user tries to submit empty email or username field',
  },
  'forgot.password.email.help.text': {
    id: 'forgot.password.email.help.text',
    defaultMessage: 'The email address you used to register with {SITE_NAME}',
    description: 'text help for the email',
  },
  'forgot.password.username.help.text': {
    id: 'forgot.password.username.help.text',
    defaultMessage: 'The username you used to register with {SITE_NAME}',
    description: 'text help for the username',
  },
  'forgot.password.emailorUsername.help.text': {
    id: 'forgot.password.emailorUsername.help.text',
    defaultMessage: 'The username or email address you used to register with {SITE_NAME}',
    description: 'text help for the username or email',
  },
  'username.format.validation.less.chars.message': {
    id: 'username.format.validation.less.chars.message',
    defaultMessage: 'Username must have at least 2 characters.',
    description: 'Validation message that appears when username is less than 2 characters',
  },
  'username.or.email.format.validation.less.chars.message': {
    id: 'username.or.email.format.validation.less.chars.message',
    defaultMessage: 'Username or email must have at least 2 characters.',
    description: 'Validation message that appears when username or email address is less than 2 characters',
  },
  // Confirmation Alert Message
  'confirmation.message.title': {
    id: 'confirmation.message.title',
    defaultMessage: 'Check your email',
    description: 'Forgot password confirmation message title',
  },
  'confirmation.support.link': {
    id: 'confirmation.support.link',
    defaultMessage: 'contact technical support',
    description: 'Technical support link text',
  },
  'need.help.sign.in.text': {
    id: 'need.help.sign.in.text',
    defaultMessage: 'Need help signing in?',
    description: 'Sign in help link on forgot password page',
  },
  'additional.help.text': {
    id: 'additional.help.text',
    defaultMessage: 'For additional help, contact {SITE_NAME} support at ',
    description: 'additional help text on forgot password page',
  },
  'sign.in.text': {
    id: 'sign.in.text',
    defaultMessage: '{label}',
    description: 'login page link on password page',
  },
  'extend.field.errors': {
    id: 'extend.field.errors',
    defaultMessage: '{emailError} below.',
    description: 'extends the field error for alert message',
  },
  // Reset password token validation failure
  'invalid.token.heading': {
    id: 'invalid.token.heading',
    defaultMessage: 'Invalid password reset link',
    description: 'Alert heading when reset password link is invalid',
  },
  'invalid.token.error.message': {
    id: 'invalid.token.error.message',
    defaultMessage: 'This password reset link is invalid. It may have been used already. Enter your email below to receive a new link.',
    description: 'Alert message when reset password link has expired or is invalid',
  },
  'token.validation.rate.limit.error.heading': {
    id: 'token.validation.rate.limit.error.heading',
    defaultMessage: 'Too many requests',
    description: 'Too many request at server end point',
  },
  'token.validation.rate.limit.error': {
    id: 'token.validation.rate.limit.error',
    defaultMessage: 'An error has occurred because of too many requests. Please try again after some time.',
    description: 'Error message that appears when server responds with 429 error code',
  },
  'token.validation.internal.sever.error.heading': {
    id: 'token.validation.internal.sever.error.heading',
    defaultMessage: 'Token validation failure',
    description: 'Failed to validate reset password token error message.',
  },
  'token.validation.internal.sever.error': {
    id: 'token.validation.internal.sever.error',
    defaultMessage: 'An error has occurred. Try refreshing the page, or check your internet connection.',
    description: 'Error message that appears when server responds with 500 error code',
  },
  // Error messages
  'internal.server.error': {
    id: 'internal.server.error',
    defaultMessage: 'An error has occurred. Try refreshing the page, or check your internet connection.',
    description: 'Error message that appears when server responds with 500 error code',
  },
  'emailorUsername.validation.message': {
    id: 'emailorUsername.validation.message',
    defaultMessage: 'Enter your username or email',
    description: 'Validation message that appears when email or username is empty',
  },
  'activate.account.not.found.message': {
    id: 'activate.account.not.found.message',
    defaultMessage: "User {email} doesn't exist.",
    description: 'Error message when the entered user is not found in the organisation',
  },
});
export default messages;
